// Use environment variable for API URL with fallback
const API = process.env.REACT_APP_API_URL || "https://os.ambertriangle.io";

// Ensure the URL doesn't have a trailing slash
const formattedAPI = API.endsWith('/') ? API.slice(0, -1) : API;

export default formattedAPI;
